//import { produce } from 'immer';
//import { ADD_SENSOR, AddSensorAction } from '../actions/AddSensor';
import { updateDeviceStates, isSensorDeviceState } from '../reducers/device_states';
import { createSlice } from '@reduxjs/toolkit';
const initialState = {};
export const slice = createSlice({
    name: 'sensors',
    initialState,
    reducers: {
        addSensor: {
            reducer: (state, action) => {
                state[action.payload.id] = {
                    id: action.payload.id,
                    temp: action.payload.temp,
                    humid: action.payload.humid,
                    time: action.payload.time,
                };
            },
            prepare: (id, temp, humid, time) => {
                return {
                    payload: {
                        id, temp, humid, time
                    }
                };
            }
        },
    },
    extraReducers: builder => {
        builder
            .addCase(updateDeviceStates, (state, action) => {
            for (const [k, s] of Object.entries(action.payload)) {
                const id = Number(k);
                if (isSensorDeviceState(s)) {
                    state[id] = {
                        id,
                        temp: s.temp,
                        humid: s.humid,
                        time: s.ts,
                    };
                }
            }
        });
    }
});
export const { addSensor, } = slice.actions;
export const sensors = slice.reducer;
